import { Core } from "@faire/design-tokens";
import { path as c1CategoryPath } from "@faire/web-api/routes/category/c1CategoryUrlId";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Button } from "@faire/web/slate/Button";
import { DismissableTooltip } from "@faire/web/slate/Tooltip";
import ClickOutside from "@faire/web/ui/ClickOutside";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";

import { useSettingDealsHub } from "@faire/retailer/settings/useSettingDealsHub";
import { useMilestone } from "@faire/retailer/stores/domain/useMilestone";

export const SaleAnnouncementTooltip = () => {
  const { strictLocalize } = useStrictLocalization();
  const isSaleHubUpdate = useSettingDealsHub();

  const {
    hasOccurred: hasDismissedSalesAnnouncement,
    setHasOccurred: setHasDismissedSalesAnnouncement,
  } = useMilestone("SALE_ANNOUNCEMENT_DISMISSED");

  const onDismiss = () => {
    setHasDismissedSalesAnnouncement();
  };

  if (hasDismissedSalesAnnouncement || !isSaleHubUpdate) {
    return null;
  }

  return (
    <ClickOutside onClickOutside={setHasDismissedSalesAnnouncement}>
      <StyledTooltip
        position="bottom"
        targetNode={<div />}
        onDismiss={onDismiss}
        contents={[
          {
            title: strictLocalize({
              defaultMessage: "Sale got an upgrade!",
              description: {
                text: "Header for a tooltip that is explaining how the navigation changed for food retailers",
                img: "https://cdn.faire.com/fastly/35aba944cb5cb2ad3e39b01a499759801eee71ea93bb8b7df0008f8d64126c0d.png",
              },
            }),
            body: strictLocalize({
              defaultMessage:
                "Explore all brand promotions and our flash deals, the deepest discounts on Faire. Go to the Sale tab to start saving.",
              description: {
                text: "Body for a tooltip that is explaining how the navigation changed for food retailers",
                img: "https://cdn.faire.com/fastly/35aba944cb5cb2ad3e39b01a499759801eee71ea93bb8b7df0008f8d64126c0d.png",
              },
            }),
          },
        ]}
        action={
          <Button
            variant="tertiary"
            tertiaryColor={Core.text.inverse}
            target="_blank"
            linkTo={c1CategoryPath("sale")}
          >
            <StrictLocalMsg
              defaultMessage="Shop Sale"
              description={{
                text: "Button to go to the Sale page",
                img: "https://cdn.faire.com/fastly/35aba944cb5cb2ad3e39b01a499759801eee71ea93bb8b7df0008f8d64126c0d.png",
              }}
            />
          </Button>
        }
      />
    </ClickOutside>
  );
};

const StyledTooltip = styled(DismissableTooltip)`
  position: absolute;
  // Center tooltip on "Sale" link
  bottom: 10px;
  left: 0;
  right: 0;
`;
